var innovationliving = innovationliving || {};
( function () {
    'use strict';
    jQuery( function () {
        innovationliving.init();
    } );
    innovationliving.init                     = function () {
        innovationliving.cylindo.init();
        innovationliving.productPageEmailForm.init();
        innovationliving.search.init();
        innovationliving.productdescriptionAnchor.init();
        innovationliving.dealersearch.init();
        innovationliving.externalImagebank.init();
        innovationliving.hrefReplacer.init();
        innovationliving.filePublisher.init();
        innovationliving.retailToggle.init();
        innovationliving.myOrders.init();
        innovationliving.downloadZipModal.init()
        innovationliving.orderSum.init();
        innovationliving.customizeProductlistForAC.init();
        innovationliving.videoObserver.init();
        innovationliving.socials.init();
        innovationliving.mastermodal.init();  
    };

    innovationliving.mastermodal = {
        init: function() {
            //e4.util.require.js({
            //    url: '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js',
            //    fallback: '',
            //    callback: null
            //}, function () {
            //    geoip2.country(function(sucess) {
            //        console.log(success);
            //    }, function(err) {
            //        console.log(err);
            //    }, {})
            //});
            var jModal = $("#js-master-notice");
            
            if(navigator.geolocation && jModal.length === 1 && sessionStorage.getItem('countrymodalprompt') != 'shown') {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var apikey = jModal.data("mapsapikey");
                    var request = 'https://maps.googleapis.com/maps/api/geocode/json?key=' + apikey + '&latlng=' + position.coords.latitude + ',' + position.coords.longitude + '&sensor=false';

                    function extractCountryCodes(arrDataResults, boolFindOne) {
                        var result = [];
                        for (var i = 0; i < arrDataResults.length; i++) {
                            for ( var j = 0; j < arrDataResults[ i ].address_components.length; j++ ) {
                                if ( arrDataResults[ i ].address_components[ j ].types[ 0 ] == 'country' ) {
                                    result.push(arrDataResults[ i ].address_components[ j ].short_name);
                                }
                                if ( arrDataResults[ i ].address_components[ j ].types.length == 2 ) {
                                    if ( arrDataResults[ i ].address_components[ j ].types[ 0 ] == 'political' ) {
                                        result.push(arrDataResults[ i ].address_components[ j ].short_name);
                                    }
                                }
                                if(boolFindOne && result.length > 0) {
                                    break;
                                }
                            }
                            if(boolFindOne && result.length > 0) {
                                break;
                            }
                        }
                        return result;
                    }
                    
                    jQuery.get(request).then(function(data) {
                        var countryCodes = extractCountryCodes(data.results, true);
                        if(countryCodes.includes('GB') || countryCodes.includes('IE')) {
                            $('#js-master-notice').modal('show');
                            sessionStorage.setItem('countrymodalprompt', 'shown');
                        }
                    });
                });
            }
        }
    }

    innovationliving.videoObserver = {
        arrVideoElements: null,
        init: function (  ) {
            if(jQuery('.js-il-video-observer-element').length > 0){
                var objScript = {
                    url: '//cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?version=4.8.0&features=IntersectionObserver%2CIntersectionObserverEntry&flags=gated',
                    callback: null
                };
                e4.util.require.js( objScript, function(){
                    console.log('__2');
                    innovationliving.videoObserver.bindEvents();
                });
            }
        },
        bindEvents: function () {
            jQuery('.js-il-video-observer-element').each(function ( intIndex, domElement ) {
                jQuery(domElement).data('videoId', Math.random());
            });
            innovationliving.videoObserver.arrVideoElements = jQuery('.js-il-video-observer-element').toArray();
            if ( innovationliving.videoObserver.arrVideoElements.length > 0 ) {
                e4.util.observer.bind( innovationliving.videoObserver.arrVideoElements, innovationliving.videoObserver.actionsForEachElement,
                        {
                            root: null,
                            rootMargin: '0px 0px 0px 0px',
                            threshold: 0
                        });
            }
        },
        arrVideoIframes: [],
        actionsForEachElement: function( element, observer ){
            
            var jElement = jQuery(element.target),
                domIframe = jElement.find('iframe')[0];
            
            console.log('__actionsForEachElement', innovationliving.videoObserver.arrVideoIframes[jElement.data('videoId')], innovationliving.videoObserver.arrVideoIframes);// jElement.data(), jQuery(domIframe).data());
            if(jQuery(domIframe).data('ready') !== 'true'){
                var objVimeo = new Vimeo.Player( domIframe );
                innovationliving.videoObserver.arrVideoIframes[jElement.data('videoId')] = objVimeo;
            }

            if ( element.isIntersecting === true ) {
                //innovationliving.videoObserver.arrVideoIframes[jElement.data('videoId')].play();
            } else {
                innovationliving.videoObserver.arrVideoIframes[jElement.data('videoId')].pause();
            }
        }
    };

    innovationliving.customizeProductlistForAC = {
        jElementAcFormContainer: jQuery('._form_5'),
        init: function (  ) {
            if(jQuery('.js-il-ac-send-productlist').length > 0){
                var observer = new MutationObserver(function (mutations){
                    mutations.forEach(function ( mutation ) {
                        if ( mutation.addedNodes.length > 0 ){
                            innovationliving.customizeProductlistForAC.modifyAcForm();
                        }
                    });
                });
                observer.observe(document.querySelector("._form_5"), {
                    childList: true,
                    attributes: true
                });
                innovationliving.customizeProductlistForAC.requireActiveCampaignScript();
                innovationliving.customizeProductlistForAC.bindEvents();
            }
        },
        requireActiveCampaignScript: function () {
            var objScript = {
                url: '//inno1711.activehosted.com/f/embed.php?id=5',
                callback: null
            };
            e4.util.require.js( objScript, function(){ });
        },
        bindEvents: function(){
            jQuery('.js-il-ac-send-productlist').on('click', function(event){
                var objProductNumbers = [],
                    strParamProductNumbers = '';
                jQuery('#js-e-productlist-filters').find('input[Name="ProductNumbers"]:checked').each(function(intIndex, domElement){
                    objProductNumbers.push(domElement.value.split( '+' ).join( '%2B' ));
                });

                if(objProductNumbers.length > 0){
                    strParamProductNumbers = '?ProductNumbers=' + objProductNumbers.join(',');
                }

                var strUniqueUrl = location.href + strParamProductNumbers;
                innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('input[data-name="url2022"]').val(strUniqueUrl);
                innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('._form-content').show();
                innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('._form-thank-you').hide();
                innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('._form_element:not(".d-none")').find('input, textarea').val('');
                jQuery('#js-il-form-ac-send-productlist').modal('show');
            });
        },
        modifyAcForm: function(){
            var arrHiddenFields = ['url2022','slger','slger_mail','country'];
            var strCountry = location.href.split('/')[3];
            innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('input[data-name="country"]').val(strCountry);
            innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('input[data-name="slger"]').val(innovationliving.customizeProductlistForAC.jElementAcFormContainer.data('userName'));
            innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('input[data-name="slger_mail"]').val(innovationliving.customizeProductlistForAC.jElementAcFormContainer.data('userEmail'));
            jQuery.each(arrHiddenFields, function(intIndex, strHiddenField){
                innovationliving.customizeProductlistForAC.jElementAcFormContainer.find('input[data-name="' + strHiddenField + '"]').closest('._form_element').addClass('d-none');
            });
        }
    };

    innovationliving.downloadZipModal         = {
        init: function () {
            innovationliving.downloadZipModal.bindEvents();
        },
        bindEvents: function () {
            jQuery( 'a[href^="/Admin/Public/DWSDownload.aspx"]' ).on( 'click', function ( event ) {
                var arrFileElms = event.currentTarget.href.split( '.' ),
                    strFileType = arrFileElms[ arrFileElms.length - 1 ],
                    shouldShowModal = localStorage.getItem('inno.ac.completed') === null;
                if ( strFileType === 'zip' && shouldShowModal === true ) {
                    jQuery( '#js-active-campaign-list-download-form-modal' ).modal( 'show' );
                    localStorage.setItem('inno.ac.completed', 'true');
                }
            } );
        }
    };
    innovationliving.retailToggle             = {
        allowToggle: true,
        init: function () {
            var isInstoreMode = jQuery( 'body' ).data('instoremode') === 'True';
            if(isInstoreMode) {
                jQuery('.js-e-nav-global').find('a[href="/dealers"]').parents('.nav-item').remove();
            }
            if ( jQuery( '.js-il-retailmode-toggle-form' ).length > 0 ) {
                innovationliving.retailToggle.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-il-retailmode-toggle-form' ).on( 'change', '.js-il-checkbox-retailmode', function ( event ) {
                if ( innovationliving.retailToggle.allowToggle ) {
                    jQuery( event.delegateTarget ).find( 'input[name="RetailMode"]' ).val( jQuery( event.target ).prop( 'checked' ) );
                    innovationliving.retailToggle.post( jQuery( event.delegateTarget ).serialize() );
                    innovationliving.retailToggle.allowToggle = false;
                    jQuery( '.js-il-retailmode-toggle-form' ).off( 'change' );
                }
            } ).on( 'click', '.js-btn-activate-instore-mode', function ( event ) {
                event.preventDefault();
                if ( innovationliving.retailToggle.allowToggle ) {
                    jQuery( event.delegateTarget ).find( 'input[name="InstoreMode"]' ).val( 'true' );
                    jQuery( event.delegateTarget ).submit();
                    innovationliving.retailToggle.allowToggle = false;
                    jQuery( '.js-il-retailmode-toggle-form' ).off( 'click' );
                }
            } );
        },
        post: function ( data ) {
            jQuery.ajax( {
                url: '',
                type: 'POST',
                data: data
            } ).done( function () {
                location.reload();
            } ).fail( function ( a, b, error ) {
                console.log( 'error', a, b, error );
            } );
        }
    };
    innovationliving.orderSum                 = {
        init: function () {
            if ( jQuery( '.js-il-ordersum-form' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-innovationliving-ordersum' );
                    innovationliving.orderSum.datepicker.set();
                    innovationliving.orderSum.setFormState();
                    innovationliving.orderSum.bindEvents();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-il-ordersum-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                innovationliving.orderSum.build( jQuery( event.target ).serialize() );
            } );
            jQuery( '.js-il-ordersum-form' ).on( 'change', function ( event ) {
                innovationliving.orderSum.setFormState();
            } );
        },
        setFormState: function () {
            var boolDisable = jQuery( '.js-il-ordersum-start-date-picker-input' ).val() === '' || jQuery( '.js-il-ordersum-end-date-picker-input' ).val() === '';
            jQuery( '.js-il-ordersum-form' ).find( '.btn' ).prop( 'disabled', boolDisable );
        },
        datepicker: {
            set: function () {
                var lang             = jQuery( 'html' ).attr( 'lang' );
                var jStartDatePicker = jQuery( '.js-il-ordersum-start-date-picker-input' );
                if ( jStartDatePicker.length > 0 ) {
                    jStartDatePicker.datepicker( {
                        language: lang,
                        format: jStartDatePicker.data( 'date-format' ),
                        autoclose: true,
                        orientation: 'bottom'
                    } );
                }
                var jEndDatePicker = jQuery( '.js-il-ordersum-end-date-picker-input' );
                if ( jEndDatePicker.length > 0 ) {
                    jEndDatePicker.datepicker( {
                        language: lang,
                        format: jEndDatePicker.data( 'date-format' ),
                        autoclose: true,
                        orientation: 'bottom'
                    } );
                }
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.ecom.accountsum.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function () {
                    jQuery( '.js-il-ordersum-form' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                }
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        },
        build: function ( objOrdersData ) {
            innovationliving.orderSum.ajax( {
                method: 'GET', 
                data: objOrdersData
            }, function ( data ) {
                jQuery( '.js-innovationliving-ordersum-container' ).html( e4.handlebars.tmpl.innovationlivingOrdersum( data ) );
                jQuery( '.js-il-ordersum-form' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            } );
        }
    };
    innovationliving.myOrders = {
        init: function () {
            if ( jQuery( '.js-innovationliving-myorders-container' ).length > 0 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-innovationliving-myorders #js-e-handlebars-tmpl-innovationliving-myorders-sort #js-e-handlebars-tmpl-innovationliving-ordertype-select' );
                    var objProductData = jQuery( '.js-innovationliving-orders-form' ).serialize();
                    innovationliving.myOrders.build( objProductData );
                    innovationliving.myOrders.bindEvents();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '.js-innovationliving-orders-form' ).on( 'change', function ( event ) {
                var jForm = jQuery( event.target ).closest( 'form' );
                jForm.find( 'input[name="pageNum"]' ).val( '1' );
                jForm.find('.js-il-reset-ordersearch-btn').prop('disabled', (jForm.find('.js-innovationliving-myorder-search-input').val() === ''));
                innovationliving.myOrders.build( jForm.serialize() );
            } );

            jQuery( '.js-innovationliving-orders-form' ).on('keydown', '.js-innovationliving-myorder-search-input',function( event ){
                if(event.keyCode == 13) {
                    event.preventDefault();
                    jQuery(event.delegateTarget).trigger('change');
                    return false;
                }
            });

            jQuery( '.js-innovationliving-orders-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
            } );
            jQuery( '.js-innovationliving-myorders' ).on( 'click', '.js-innovationliving-set-pagenum', function ( event ) {
                var strVal = jQuery( event.target ).closest( 'a' ).data( 'pageNum' ),
                    jForm  = jQuery( '.js-innovationliving-orders-form' );
                jForm.find( 'input[name="pageNum"]' ).val( strVal );
                innovationliving.myOrders.build( jForm.serialize() );
            } );
            jQuery( '.js-innovationliving-orders-form' ).on( 'click', '.js-il-reset-ordersearch-btn', function ( event ) {
                if(jQuery(event.delegateTarget).find('.js-innovationliving-myorder-search-input').val() !== ''){
                    jQuery(event.delegateTarget).find('.js-innovationliving-myorder-search-input').val('').trigger('change');
                }
            } );
        },
        build: function ( objOrdersData ) {
            innovationliving.myOrders.ajax( {
                method: 'GET',
                data: objOrdersData
            }, function ( data ) {
                var jElemetSearchField = jQuery('.js-innovationliving-myorder-search-input');
                var strPlaceholder = jElemetSearchField.data('placeholder');
                if(data.orderType === 'invoice'){
                    strPlaceholder = jElemetSearchField.data('invoicePlaceholder');
                }
                jElemetSearchField.attr('placeholder', strPlaceholder);
                jQuery( '.js-innovationliving-myorders' ).find( '.js-orders-count' ).text( data.itemCount );
                jQuery( '.js-innovationliving-myorders-container' ).html( e4.handlebars.tmpl.innovationlivingMyorders( data ) );
                jQuery( '.js-innovationliving-myorders-sort-container' ).html( e4.handlebars.tmpl.innovationlivingMyordersSort( data ) );
                jQuery( '.js-innovationliving-ordertype-select-container' ).html( e4.handlebars.tmpl.innovationlivingOrdertypeSelect( data ) );
                jQuery( '.js-innovationliving-myorders' ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            } );
        },
        pdfWindow: null,
        pdf: {
            get: function ( objData ) {
                console.log( '0', objData );
                innovationliving.myOrders.pdf.ajax( {
                    method: 'GET',
                    data: objData
                }, function ( response ) {
                    if ( response === 'fejl' || response === 'no_result' ) {
                        alert( 'Sorry - Can´t get the order.' );
                    }
                    else {
                        location.href = e4.settings.ecom.myorders.pdf.url + '?' + objData;
                    }
                } );
            },
            ajax: function ( objAjaxSettings, fnCallback ) {
                var jqXHR = jQuery.ajax( jQuery.extend( {
                    url: e4.settings.ecom.myorders.pdf.url,
                    method: 'GET',
                    dataType: 'text',
                    cache: false,
                    beforeSend: function () {
                        innovationliving.myOrders.pdfWindow = window;
                    }
                }, objAjaxSettings ) );
                jqXHR.done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            }
        },
        ajax: function ( objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                url: e4.settings.ecom.myorders.url,
                method: 'POST',
                dataType: 'json',
                cache: false,
                beforeSend: function () {
                    jQuery( '.js-innovationliving-myorders' ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
                }
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        }
    };
    innovationliving.filePublisher            = {
        init: function () {
            if ( jQuery( '.js-il-filepublisher-form' ).length > 0 ) {
                innovationliving.filePublisher.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-il-filepublisher-form' ).on( 'change', function ( event ) {
                jQuery( '.js-il-filepublisher-loading-overlay' ).addClass( 'is-loading' );
                jQuery( '.js-il-filepublisher-container' ).css( {
                    'overflow': 'hidden',
                    'height': '10em'
                } );
                jQuery( '.js-il-filepublisher-form' ).submit();
            } );
        }
    };

    innovationliving.hrefReplacer = {
        init: function () {
            if ( jQuery( '.js-href-replace' ).length > 0 ) {
                innovationliving.hrefReplacer.replaceHrefs();
            }
        },
        replaceHrefs: function () {
            jQuery( '.js-href-replace' ).each( function ( intIndex, domElement ) {
                jQuery( domElement ).attr( 'href', jQuery( domElement ).data( 'link' ) );
            } );
        }
    };
    innovationliving.externalImagebank = {
        init: function () {
            if ( jQuery( '.js-il-open-external-imagebank' ).length > 0 ) {
                innovationliving.externalImagebank.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-il-open-external-imagebank' ).on( 'click', function ( event ) {
                event.preventDefault();
                jQuery( '#login_form_europe' ).submit();
            } );
        }
    };
    innovationliving.socials                  = {
        init: function () {
            innovationliving.socials.instagram.init();
        },
        instagram: {
            init: function () {
                if ( jQuery( '#instagram-feed' ).length > 0 ) {
                    jQuery.getScript( '/Files/Templates/Designs/innovationliving/_assets/js/vendor/instafeed.js', function () {
                        innovationliving.socials.instagram.build();
                    } );
                }
            },
            build: function () {
                var jFeed     = jQuery( '.instagram-feed' ),
                    jLimit    = parseInt( jFeed.data( 'limit' ) ),
                    jCaption  = jFeed.data( 'caption' ),
                    jCaptions = '',
                    jUserType = jFeed.data( 'type' ), //jUserTypes = '',
                    jGet      = 'user',
                    jUser     = jFeed.data( 'user' ),
                    jToken    = jFeed.data( 'token' ),
                    jTagged   = jFeed.data( 'tags' );
                if ( jCaption === 'True' ) {
                    jCaptions = '<div class="instagram-feed-item-caption"><p>{{caption}}</p></div>';
                }
                if ( jUserType === 'True' ) {
                    jGet = 'user';
                }
                var i = new Instafeed( {
                    get: jGet,
                    tagName: jTagged,
                    userId: jUser,
                    accessToken: jToken,
                    limit: jLimit,
                    success: function ( data ) {
                        if ( jGet === 'user' ) {
                            jTagged = data.data[ 0 ].user.username;
                        }
                    },
                    target: 'instagram-feed',
                    resolution: 'standard_resolution', 
                    template: '<div class="instagram-feed-item col-12 col-md-6 col-lg-3">' + '<img class="caption" src="{{image}}" alt="{{caption}}">' + jCaptions + '</div>'
                } );
                i.run();
                //<div class="instagram-feed-item"><a style="background-image:url({{image}}); background-size:cover;"
                // href="{{link}}" target="_blank"><img src="/Files/Templates/Designs/nordlux/assets/img/trans.png"
                // title="{{caption}}"/>' + jCaptions + '</a></div>
            }
        }
    };
    innovationliving.productPageEmailForm     = {
        init: function () {
            // Hidden fields in formular, gets product name and product number
            jQuery( '.js-il-product-page-email-form input.js-ecom-product-name-form' ).val( jQuery( 'input[name="ProductName"]' ).val() );
            jQuery( '.js-il-product-page-email-form input.js-ecom-product-id-form' ).val( jQuery( 'input[name="ProductNumber"]' ).val() );
        }
    };
    innovationliving.search                   = {
        init: function () {
            jQuery( '.js-il-search-form' ).on( 'submit', function ( event ) {
                event.preventDefault();
                var customSearchBarValue = jQuery( event.target ).find( '.js-il-search-input' ).val();
                e4.util.hash.set( 'search', customSearchBarValue ); 
            } );
        }
    };
    innovationliving.productdescriptionAnchor = {
        init: function () {
            jQuery( '.js-scroll-to-description' ).on( 'click', function ( event ) {
                event.preventDefault();
                var collapseTarget = jQuery( event.target ).data( 'target' );
                jQuery( collapseTarget ).collapse( 'show' );
                e4.scrollToAnchor.animate( e4.scrollToAnchor.getTarget( event.target.hash ), e4.header.hide );
            } );
        }
    };
    innovationliving.popover                  = function () {
        jQuery( '[data-toggle="popover"]' ).popover();
    };
    innovationliving.dealersearch             = {
        options: {
            url: '/system/data/dealers-online',
            lang: jQuery( 'html' ).attr( 'lang' )
        },
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-dealersearch' );
                    innovationliving.dealersearch.helpers();
                    innovationliving.dealersearch.bindEvents();
                    innovationliving.dealersearch.get();
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-container' ).on( 'change', '.js-innovationliving-country-selector', function () {
                jQuery( '.js-innovationliving-country' ).hide();
                if ( !jQuery( this ).val() ) {
                    jQuery( this ).val( '' );
                    jQuery( '.js-innovationliving-country' ).fadeIn( 'slow' );
                }
                else {
                    jQuery( '.js-innovationliving-country[data-contry-code="' + jQuery( this ).val() + '"]' ).fadeIn( 'slow' );
                }
            } ).trigger( 'change' );
        },
        helpers: function () {
            Handlebars.registerHelper( 'isDistributor', function ( country, dealers, options ) {
                for ( var i = 0; i < dealers.length; i++ ) {
                    if ( dealers[ i ].country.countryCode === country ) {
                        if ( dealers[ i ].distributor.value === true ) {
                            return options.fn( this );
                        }
                    }
                }
                return options.inverse( this );
            } );
        },
        get: function () {
            jQuery.ajax( {
                url: innovationliving.dealersearch.options.url,
                type: 'GET',
                dataType: 'json'
            } )
                    .done( function ( data ) {
                        innovationliving.dealersearch.build( data );
                    } )
                    .fail( function ( error ) {
                        console.error( error );
                    } );
        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-container' );
            jQuery.each( data.selectList, function ( index, country ) {
                if ( country.countryCode === jContainer.data( 'default-country' ) ) {
                    country.isSelected = true;
                }
            } );
            jContainer.html( e4.handlebars.tmpl.dealersearch( data ) );
            jContainer.find( '.js-innovationliving-country-selector' ).val( jContainer.data( 'default-country' ) ).trigger( 'change' );
        }
    };
}() );
e4.util.observer = {
    _instances: [],
    options: {
        root: null,
        rootMargin: '0px',
        threshold: 0
    },
    bind: function ( arrTargets, fnCallback, objOptions ) {
        //if ( 'IntersectionObserver' in window === false ) {
        //    e4.util.require.polyfills( 'IntersectionObserver IntersectionObserverEntry', e4.util.observer.observe(
        // arrTargets, fnCallback, objOptions ) ); } else {
        e4.util.observer.observe( arrTargets, fnCallback, objOptions );
        //}
    },
    observe: function ( arrTargets, fnCallback, objOptions ) {
        var instance     = {};
        instance.id      = '_instance' + Math.random().toString( 36 ).substr( 2, 9 );
        instance.options = objOptions !== undefined ? objOptions : e4.util.observer.options;
        arrTargets.forEach( function ( target ) {
            instance.observer = new IntersectionObserver( function ( entries, observer ) {
                entries.forEach( function ( entry ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( entry, observer );
                    }
                    else {
                        console.warn( 'No callback function defined' )
                    }
                } );
            }, instance.options );
            instance.observer.observe( target );
        } );
        e4.util.observer._instances.push( instance );
    }
};
